import { render, staticRenderFns } from "./access-details-card.vue?vue&type=template&id=375d3de8&scoped=true"
import script from "./access-details-card.vue?vue&type=script&lang=ts"
export * from "./access-details-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d3de8",
  null
  
)

export default component.exports